// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"Pagination_paginationContainer__3HZl9","button":"Pagination_button__SJ3_Y","active":"Pagination_active__2fpbl"};